// @flow

import React, { PureComponent } from 'react';
import type { RankingType } from 'src/types/Ranking';
import { getPublicAssets } from 'utils/assetsUtils';
import type { LastResultType } from 'types/Ranking';
import { doesClubHasWonMatch } from 'utils/graphResponseUtils';
import { ffrName } from 'utils/ffrNameUtils';

type Props = {
  classement: RankingType[],
  className?: string
};

export default class RankingTable extends PureComponent<Props> {
  static defaultProps = {
    className: 'ranking box box--smoke mb-3 mb-lg-0'
  };

  renderVictoriesHistory = (matches: LastResultType[], id: string): React$Element<any>[] => {
    return matches.map(({ local, visiteur }, i) => {
      const clubHasWon = local && visiteur && doesClubHasWonMatch({ local, visiteur, id });
      const className = (clubHasWon && 'has-win') || '';
      const nameLocal = local ? (local.structure ? local.structure.nom : local.regroupement.nom) : '';
      const nameVisiteur = visiteur ? (visiteur.structure ? visiteur.structure.nom : visiteur.regroupement.nom) : '';
      const itemTitle =
        (local &&
          visiteur &&
          `${ffrName(nameLocal)} ${local.pointsTerrains || 0} -` + ` ${ffrName(nameVisiteur)} ${visiteur.pointsTerrains || 0}`) ||
        `${new Date().getTime() + Math.random()}`; //@TODO : Remove this when it'll be sure to always have data
      return <li key={itemTitle} title={itemTitle} className={className} />;
    });
  };

  renderRow = () => {
    const { classement } = this.props;
    if (!classement) {
      return (
        <div className="placeholder">
          <p className="ft-h5">
            <br />
            <i className="icon icon-articles-empty"></i>
            <br />
            <strong>Aucun classement</strong>
            <br />
            Le classement de la compétition n’est pas encore disponible.
          </p>
        </div>
      );
    }

    return classement.map<any>(({ nom, pointTerrain, joues, gagnes, nuls, perdus, position, id, embleme, lastResult }, index) => {
      const clubSlug = nom
        .toLowerCase()
        .split(' ')
        .join('-');
      const clubPlaceholder = getPublicAssets('/img/logo/placeholder-club.png');
      const nomLower = ffrName(nom);
      return (
        <tr key={nom}>
          <td className="ranking__count">
            <abbr title="Classement">{position}</abbr>
          </td>
          <td className="ranking__name">
            <p>
              <a href={`https://monclubhouse.ffr.fr/clubs/${clubSlug}`}>
                <img src={embleme || clubPlaceholder} alt={`Logo ${nomLower}`} style={{ width: '32', height: '32' }} />
                {nomLower}
              </a>
            </p>
          </td>
          <td className="ranking__point">
            <abbr title="Points">{pointTerrain}</abbr>
          </td>
          <td className="ranking__stat">
            <abbr title="Joués">{joues}</abbr>
          </td>
          <td className="ranking__stat">
            <abbr title="Gagnés">{gagnes}</abbr>
          </td>
          <td className="ranking__stat">
            <abbr title="Nuls">{nuls}</abbr>
          </td>
          <td className="ranking__stat">
            <abbr title="Perdus">{perdus}</abbr>
          </td>
          <td>
            <ul className="ranking__history">{this.renderVictoriesHistory(lastResult, id)}</ul>
          </td>
        </tr>
      );
    });
  };

  render() {
    const { className, classement } = this.props;

    if (!classement) {
      return (
        <div className="placeholder">
          <p className="ft-h5">
            <br />
            <i className="icon icon-articles-empty"></i>
            <br />
            <strong>Aucun classement</strong>
            <br />
            Le classement de la compétition n’est pas encore disponible.
          </p>
        </div>
      );
    }
    return (
      <div className={className}>
        <table>
          <thead>
            <tr>
              <th className="ranking__count">
                <abbr title="Classement">#</abbr>
              </th>
              <th className="ranking__name">Clubs</th>
              <th className="ranking__point">
                <abbr title="Points">Pts</abbr>
              </th>
              <th className="ranking__stat">
                <abbr title="Joués">J</abbr>
              </th>
              <th className="ranking__stat">
                <abbr title="Gagnés">G</abbr>
              </th>
              <th className="ranking__stat">
                <abbr title="Nuls">N</abbr>
              </th>
              <th className="ranking__stat">
                <abbr title="Perdus">P</abbr>
              </th>
              <th className="ranking__last">
                <abbr title="Forme">Forme</abbr>
              </th>
            </tr>
          </thead>
          <tbody>{this.renderRow()}</tbody>
        </table>
      </div>
    );
  }
}
